import { render } from "./Button.vue?vue&type=template&id=f3625eaa"
import script from "./Button.vue?vue&type=script&lang=js"
export * from "./Button.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/elyosdigital.com/_build/workspace/MySchool/myschool.elyosdigital.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/buttons/Button.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f3625eaa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f3625eaa', __exports__)) {
    console.log('reload')
    api.reload('f3625eaa', __exports__)
  }
  
  module.hot.accept("./Button.vue?vue&type=template&id=f3625eaa", () => {
    console.log('re-render')
    api.rerender('f3625eaa', render)
  })

}


export default __exports__